// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S1VX","footer":"styles_footer__1VKFP","passCodeTooltip":"styles_passCodeTooltip__nYakK"};